import { render, staticRenderFns } from "./team-profile-individual-global.vue?vue&type=template&id=89f7fe20&scoped=true&"
import script from "./team-profile-individual-global.vue?vue&type=script&lang=js&"
export * from "./team-profile-individual-global.vue?vue&type=script&lang=js&"
import style0 from "./team-profile-individual-global.vue?vue&type=style&index=0&id=89f7fe20&scoped=true&lang=css&"
import style1 from "./team-profile-individual-global.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./team-profile-individual-global.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f7fe20",
  null
  
)

export default component.exports